import type { Step } from "react-joyride";

/** Versione 2 (2026-09-12): privacy e consensi. */
export const dettaglioClienteVersion = 2;

export const dettaglioClienteSteps: Step[] = [
  {
    target: '[data-tour="cliente-anagrafica"]',
    title: "Dati anagrafici",
    content: (
      <p>
        Email, telefono, CF/P.IVA, IBAN, indirizzo e numero pratiche
        collegate. Dati sincronizzati dal CRM.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="cliente-privacy"]',
    title: "Privacy e consensi",
    content: (
      <p>
        Se il cliente ha visto l'informativa e cosa ha acconsentito a ricevere.
        Se non risulta, <strong>Reinvia link privacy</strong> gliela rimanda.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="cliente-documento"]',
    title: "Documento identità",
    content: (
      <p>
        Se presente, scarica la carta d'identità o il passaporto caricato
        in fase di raccolta dati.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="cliente-pratiche"]',
    title: "Pratiche del cliente",
    content: (
      <p>
        Tutte le pratiche di questo cliente. Clicca una riga per aprire la
        scheda pratica completa.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
];
